/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
	PaymentHistoryCtlDto,
	PaymentInfoResponseDto,
	PaymentPlanResponseDto,
	PaymentResponseDto,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Payment<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description 결제 플랜
	 *
	 * @tags /payment
	 * @name DoGetPaymentPlan
	 * @summary 결제 플랜
	 * @request GET:/payment/plan
	 * @secure
	 * @response `200` `(PaymentPlanResponseDto)[]` OK
	 * @response `500` `(PaymentPlanResponseDto)[]` 서버오류
	 */
	doGetPaymentPlan = (params: RequestParams = {}) =>
		this.http.request<PaymentPlanResponseDto[], PaymentPlanResponseDto[]>({
			path: `/payment/plan`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /payment
	 * @name DoGetPaymentList
	 * @summary 결제 리스트
	 * @request GET:/payment/list
	 * @secure
	 * @response `200` `(PaymentResponseDto)[]` OK
	 * @response `500` `(PaymentResponseDto)[]` 서버오류
	 */
	doGetPaymentList = (params: RequestParams = {}) =>
		this.http.request<PaymentResponseDto[], PaymentResponseDto[]>({
			path: `/payment/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /payment
	 * @name DoGetPaymentHistory
	 * @summary 결제 히스토리 (추가: 2023.08)
	 * @request GET:/payment/history
	 * @secure
	 * @response `200` `PaymentHistoryCtlDto` [code]<br />server.error: 서버 오류<br /><br />
	 */
	doGetPaymentHistory = (
		query: { page: number; pageSize: number },
		params: RequestParams = {},
	) =>
		this.http.request<PaymentHistoryCtlDto, any>({
			path: `/payment/history`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description 현재 시점의 플랜을 반환합니다.
	 *
	 * @tags /payment
	 * @name DoGetPaymentCurrent
	 * @summary 현재 시점의 플랜
	 * @request GET:/payment/current
	 * @secure
	 * @response `200` `PaymentInfoResponseDto` OK
	 * @response `400` `PaymentInfoResponseDto` 입력 데이터 확인
	 */
	doGetPaymentCurrent = (params: RequestParams = {}) =>
		this.http.request<PaymentInfoResponseDto, PaymentInfoResponseDto>({
			path: `/payment/current`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
}
